import "@esri/calcite-components/components/calcite-menu";
import "@esri/calcite-components/components/calcite-menu-item";

import { COMMON_TASK_BAR_ITEMS } from './menuConfigs';

import './mapTaskBar.css';
import PropTypes from 'prop-types';

const MapTaskBar = ({ onMapTaskbarItemClick }) => {
  return (
    <calcite-menu slot="content-start">
      {COMMON_TASK_BAR_ITEMS.map((item) => (
        <calcite-menu-item
          key={item.id}
          icon-start={item.icon}
          breadcrumb={item.breadcrumb}
          onClick={() => onMapTaskbarItemClick(item.id)}
          data-testid={item.id}
        />
      ))}
    </calcite-menu>
  );
};

MapTaskBar.propTypes = {
  onMapTaskbarItemClick: PropTypes.func.isRequired,
};

export default MapTaskBar;